import { motion, useInView } from 'motion/react';
import React, { useRef } from 'react';
import styled from 'styled-components';
import { device } from '../../../constants';
import { ANIMATION_CONFIG } from '../../../constants/animationConfig';

interface MotionAboutUsSwiperProps {
  className?: string;
  imageComponent: React.ReactNode;
  swiperComponent: React.ReactNode;
}

export const MotionAboutUsSwiper = ({
  imageComponent,
  swiperComponent,
  className,
}: MotionAboutUsSwiperProps) => {
  const ref = useRef(null);

  return (
    <MotionAboutUsSwiperWrapper
      className={className}
      ref={ref}
    >
      <ImageWrapper>{imageComponent}</ImageWrapper>
      <SwiperWrapper>{swiperComponent}</SwiperWrapper>
    </MotionAboutUsSwiperWrapper>
  );
};

const MotionAboutUsSwiperWrapper = styled(motion.div)`
  display: flex;
  flex: 1;

  @media screen and (${device.md}) {
    justify-content: center;
  }
`;

const ImageWrapper = styled(motion.div)``;
const SwiperWrapper = styled(motion.div)``;
